import axios from 'axios';
import settings from '../libs/config';
import Logger from './logging';

import * as persistent from './persistent';

const USER_LOCATION = "pil_location";

export const fetchUserLocation = async () => {
	Logger.log("geolocation.js", "fetchUserLocation() settings", settings);

	if (!settings.geoEnabled) {
		return false;
	}

	const data = await getClientIPInfo();

	if (!data) {
		Logger.warn("geolocation.js", "fetchUserLocation() no user data");
		return null;
	}

	let userInfo = {
		ip: data.ip,
		req_ip: data.req_ip,
		x_real_ip: data.x_real_ip,
		country_code: data.country_code,
		country_name: data.country_name,
		region_code: data.region_code,
		region_name: data.region_name,
		city: data.city,
		zip: data.zip,
		is_eu: (data.location ? data.location.is_eu : null),
	};

	Logger.log("geolocation.js", "fetchUserLocation() userInfo", userInfo);

	return userInfo;
};

export const storeUserLocation = (location) => {
	persistent.setSessionValue(USER_LOCATION, JSON.stringify(location));
};

export const removeUserLocation = (location) => {
	persistent.removeSessionValue(USER_LOCATION);
};

export const loadUserLocation = () => {
	let location = null;
	try {
		const locationStr = persistent.getSessionValue(USER_LOCATION);
		if (locationStr) {
			location = JSON.parse(locationStr);
		}
	}
	catch (err) {
		Logger.warn("geolocation.js", "loadUserLocation() failed to parse user location.");
	}
	return location;
};

export const isUserInUS = () => {
	Logger.log("geolocation.js", "isUserInUS()");

	let inUS = null;

	let location = loadUserLocation();
	// if (!location) {
	// 	location = await fetchUserLocation();
	// 	storeUserLocation(location);
	// }
	if (location) {
		inUS = !location.country_code || location.country_code === "US";
	}

	if (inUS === true || inUS === false) {
		Logger.log("geolocation.js", "isUserInUS() inUS", inUS);
	}
	else {
		Logger.warn("geolocation.js", "isUserInUS() inUS unknown", inUS);
	}

	return inUS;
};

export const isUserInEU = () => {
	Logger.log("geolocation.js", "isUserInEU()");

	let isEU = null;

	let location = loadUserLocation();
	// if (!location) {
	// 	location = await fetchUserLocation();
	// 	storeUserLocation(location);
	// }
	if (location) {
		isEU = location.is_eu;
	}

	if (isEU === true || isEU === false) {
		Logger.log("geolocation.js", "isUserInEU() is_eu", isEU);
		return isEU;
	}
	else {
		Logger.warn("geolocation.js", "isUserInEU() is_eu unknown", isEU);
		return false;
	}
};

export const getClientIPInfo = async () => {
	let url = settings.portal_url + '/ipinfo';

	Logger.log("geolocation.js", "getClientIPInfo()", url);

	try {
		const response = await axios.post(url);

		if (response && response.data) {
			Logger.log("geolocation.js", "getClientIPInfo() ipinfo", response.data);

			return response.data;
		}
		else {
			Logger.error("geolocation.js", "getClientIPInfo() request failed", response);
			throw new Error("Request Failed");
		}
	} catch (error) {
		Logger.error("geolocation.js", "getClientIPInfo() error", error);
		throw new Error(error);
	}
};


// WEBPACK FOOTER //
// ./src/functions/geolocation.js